import React from "react";
import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { DotLegalSelectOption } from "@common/components/dotLegalMultiSelect/DotLegalMultiSelect.types.ts";
import { getEnumValues } from "@common/enumOperations.ts";
import { setFirstLetterToLowerCase } from "@common/stringOperations.ts";
import { useTranslation } from "@localization/useTranslation.ts";
import { IncidentLogEntryStatus } from "../../../incidentLog/IncidentLogDialog.types.ts";

export interface IncidentLogStatusFieldProps {
    status?: IncidentLogEntryStatus;
    onChange: (status: IncidentLogEntryStatus) => void;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogStatusField(props: IncidentLogStatusFieldProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalSelect
            options={getIncidentLogStatusOptions(translateString)}
            selectedItem={props.status ? props.status.toString() : null}
            onChange={(status) => props.onChange(Number(status) as IncidentLogEntryStatus)}
            placeholder={translateString("status")}
            label={translateString("status")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
            disableClearable
        />
    );
}

function getIncidentLogStatusOptions(translateString: (key: string) => string): Array<DotLegalSelectOption> {
    return getEnumValues(IncidentLogEntryStatus).map((status) => ({
        id: status.toString(),
        name: translateString(setFirstLetterToLowerCase(IncidentLogEntryStatus[status])),
    }));
}

export default IncidentLogStatusField;
